import React from "react";

const NoMatch = () => {
  return (
    <div
      style={{
        // backgroundImage: `url("${image}")`,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh"
      }}
    >
      <div
        style={{
          padding: "50px",
          border: "7px solid black"
        }}
      >
        <h1
          style={{
            fontSize: "8rem",
            display: "inline",
            fontWeight: "600",
          }}
        >
          404{" "}
        </h1>
        <i style={{ fontSize: "8rem" }} class="icon ion-md-bug"></i>
        <h1 style={{ fontSize: "3.5rem", color: "#ad0900" }}>
          Stranica nije pronađena
        </h1>
        <h1 style={{ color: "#ad0900" }}>Odabrali ste nepostojeću stranicu</h1>
      </div>
    </div>
  );
};

export default NoMatch;
